"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var MessageService = /** @class */ (function () {
    function MessageService(store, http) {
        this.store = store;
        this.http = http;
        this.$mlUrl = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.map(function (propertyMap) { return lodash_1.get(propertyMap, 'ml-service-url'); }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for ml-service-url was not found')));
    }
    MessageService.prototype.loadMessages = function (languageId) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return this.$mlUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/messages", {
                params: {
                    languageId: languageId.toString(),
                    keys: keys.join(','),
                },
            })
                .pipe(operators_1.map(function (value) {
                return immutable_1.List(lodash_1.entries(lodash_1.set(value, '', ''))).map(function (message) {
                    return skynet_store_messages_api_1.MessageFactory({
                        key: skynet_store_messages_api_1.MessageKeyFactory({
                            languageId: languageId,
                            name: message[0],
                        }),
                        value: message[1],
                    });
                });
            }));
        }));
    };
    MessageService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [store_1.Store,
            http_1.HttpClient])
    ], MessageService);
    return MessageService;
}());
exports.MessageService = MessageService;
//# sourceMappingURL=message.service.js.map